module.exports = __webpack_public_path__ + "media/images/pages/about_us/partners/logo_aquiti-f377f6894d8cb4de37d725827a0c7284.png";